import React, { useEffect } from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { ITheme } from "../../Layout/themes";
import { loadTicketReceivingData, acceptTicket } from "./actions";
import { connect } from "react-redux";
import { IStoreState } from "../../Store";
import {
  ITicketReceiveState,
  ShareStatus,
  IEnvironment
} from "../../../interface/IShareInfo";
import { MobileAppsRedirectButtonGroup } from "./MobileAppsRedirectButtonGroup";
import { isMobileDevice } from "../../../commons/utils/validations";
import { MobileAppsRedirectImage } from "./MobileAppsRedirectImage";

export const commonStaticContentStyles = createStyles({});

const useStyles = makeStyles(({ palette }: ITheme) => {
  return createStyles({});
});

interface IProps {
  ticketReceivingData: ITicketReceiveState;
  env: IEnvironment
}

export const MobileAppsRedirectFooterComponent = ({
  ticketReceivingData: { loading, data, error, postStep, firstAccepted },
  env
}: IProps) => {
  const view_ticket_page = data && data.shareStatus === ShareStatus.Accepted;
  if (firstAccepted && view_ticket_page && isMobileDevice()) {
    return (
      <div>
        <MobileAppsRedirectButtonGroup env={env}></MobileAppsRedirectButtonGroup>
        <MobileAppsRedirectImage></MobileAppsRedirectImage>
      </div>
    );
  }
  return <div style={{ marginBottom: 80 }}></div>;
};

const mapStateToProps = (state: IStoreState) => {
  return {
    ticketReceivingData: state.ticketReceiveData,
    env: state.env
  };
};

export const MobileAppsRedirectFooter = connect(
  mapStateToProps,
  null
)(MobileAppsRedirectFooterComponent);
